import { createAsyncTypes } from 'utils/ActionCreator'

export const LANDING_FROM_REQUEST_ASYNC = createAsyncTypes(
  'LANDING_FROM_REQUEST_ASYNC',
  'Settings/MailboxProtection'
)
export const LANDING_FROM_UPDATE_ASYNC = createAsyncTypes(
  'LANDING_FROM_UPDATE_ASYNC',
  'Settings/MailboxProtection'
)

export const INPUT_CHANGE = 'Settings/MailboxProtection/INPUT_CHANGE'

export const LABELS = {
  first_title: 'Landing page first title:',
  first_paragraph: 'Landing page first paragraph:',
  second_title: 'Landing page second title:',
  second_paragraph: 'Landing page second paragraph:',
  third_title: 'Landing page third title:',
  third_paragraph: 'Landing page third paragraph:',
  sender_button: 'Button 1:',
  domain_button: 'Button 2:',
  title: 'Landing page title:',
  confirm_paragraph: 'Confirmation page paragraph:',
  mark_as_a_known_button: 'Mark as known button',
  mark_as_an_unknown_button: 'Mark as unknown button',
  voting_feedback: 'Voting feedback',
}

export const ORDER = {
  first_title: 1,
  first_paragraph: 2,
  second_title: 3,
  second_paragraph: 4,
  third_title: 5,
  third_paragraph: 6,
  sender_button: 7,
  domain_button: 8,
  title: 1,
  confirm_paragraph: 2,
  mark_as_a_known_button: 3,
  mark_as_an_unknown_button: 4,
  voting_feedback: 5,
}

export const HEBREW_LOCALE_CONST = 2
